import React from "react";
import heroImg from "../../assets/images/home/heroImg.png";
import "./index.css";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <div className="heroBanner">
      <div className="container">
        <div className="heroGrid">
          <div className="heroLeft">
            <div className="heroTitle">Bid Smarter, Own Faster.</div>
            <div className="heroSubTitle">
              Discover plots, homes, and properties. Express interest online —
              bid offline with confidence.
            </div>
            <div className="heroBtnContainerHome">
              <Link to="/contact">
                <button className="btnHeroContact">Contact Us</button>
              </Link>
              <Link to="/properties">
                <button className="btnHeroBrowse">Browse Properties</button>
              </Link>
            </div>
            <div className="heroCardGrid">
              <div className="heroCard">
                <div>200+</div>
                <div>Happy Customers</div>
              </div>
              <div className="heroCard">
                <div>10k+</div>
                <div>Properties For Clients</div>
              </div>
              <div className="heroCard">
                <div>5+</div>
                <div>Years of Experience</div>
              </div>
            </div>
          </div>
          <div className="heroRight">
            <img src={heroImg} />
          </div>
        </div>
      </div>
    </div>
  );
};
